// Lib
import React from 'react';

// Components
import { ReactComponent as GileadLogo } from '../../../assets/svg/gileadLogo.svg';

// Hooks
import useUI from '../../../hooks/useUI';

// Utils
import { getCurrentYear } from '../../../utils/date';

// Assets
import kiteLogo from '../../../assets/img/kiteLogo.png';

// Styles
import { useStyles } from './FooterStyles';

const Footer = ({ isKiteUser, className }) => {
  const { classes, cx } = useStyles();
  const { isDesktopMode } = useUI();

  return (
    <>
      {isDesktopMode ? (
        <footer className={cx(classes.root, className)}>
          <div className={classes.container}>
            {isKiteUser ? (
              <img
                alt="logo"
                width={'121'}
                height={'36px'}
                src={kiteLogo}
                data-testid="kite-logo"
              />
            ) : (
              <GileadLogo />
            )}
            <div className={classes.rights}>
              {`${getCurrentYear()} Gilead Sciences, Inc. All Rights Reserved.`}
            </div>
          </div>
        </footer>
      ) : null}
    </>
  );
};

export default Footer;
